(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    const initSwatches = (root) => {
      if (!root) return;
      if (window.GroupSwatches) {
        window.GroupSwatches.init(root);
        return;
      }

      const onGroupSwatchesReady = () => {
        if (window.GroupSwatches) window.GroupSwatches.init(root);
        window.removeEventListener('groupswatches:ready', onGroupSwatchesReady);
      };

      window.addEventListener('groupswatches:ready', onGroupSwatchesReady, { once: true });
    };

    const loadRecommendations = () => {
      // Prevent double-loading
      if (this.classList.contains('loaded')) return;
      this.classList.add('loaded');

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            initSwatches(this);
          }
          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }

          // Initialize swiper sliders
          var productslider = [];
          document.querySelectorAll('.product-carousel').forEach(function (Element) {
            let productid = Element.dataset.id;
            let outer_carousel = Element.closest('.carousel-rowouter');
            let nextbutton = outer_carousel.querySelector('.swiper-button-next');
            let prevbutton = outer_carousel.querySelector('.swiper-button-prev');
            let swiperObject = {
              loop: eval(Element.dataset.loop),
              slidesPerView: "auto",
              freeMode: {
                enabled: true,
                momentum: true,
                momentumRatio: 0.3,
                momentumVelocityRatio: 0.3,
              },
              mousewheel: {
                forceToAxis: true,
                sensitivity: 1,
                releaseOnEdges: true,
              },
              speed: 1000,
            };
            productslider[productid] = new Swiper(Element, swiperObject);
          });

          if (typeof quickAddButton == 'function') {
            quickAddButton();
          }

          // Color variant click handler
          if (window.innerWidth > 1024) {
            document.querySelectorAll('.grid-bottom .main-color-variant .color-var.click').forEach(function (element) {
              element.addEventListener('click', function (event) {
                event.preventDefault();
                var attVal = this.getAttribute('data-id');
                var productItem = this.closest('.product-item');
                var innerGrids = productItem.querySelectorAll('.snippet-product-grid .inner-product-grid');
                innerGrids.forEach(function (innerGrid) {
                  innerGrid.classList.toggle('active', attVal === innerGrid.getAttribute('data-id'));
                });
              });
            });
          }
        })
        .catch(e => console.error(e));
    };

    // Load when visible
    new IntersectionObserver((entries, observer) => {
      if (entries[0].isIntersecting) {
        observer.unobserve(this);
        loadRecommendations();
      }
    }, { rootMargin: '0px 0px 200px 0px' }).observe(this);

    // Also load on page load (immediate fallback)
    window.addEventListener('DOMContentLoaded', () => {
      loadRecommendations();
    });
  }
}

customElements.define('product-recommendations', ProductRecommendations);


  } catch(e) { console.error(e); }
})();
})();
